import create from 'zustand'

import { StatusTypes, StatusErrorTypes } from 'types/status'
import { FileTypesDataTypes, FilesDataTypes } from 'schemas/files'

interface FilesStoreTypes {
  fileTypesModErrors: StatusErrorTypes
  fileTypesModErrorsSet: (fileTypesModErrors: StatusErrorTypes) => void
  fileTypesModStatus: StatusTypes
  fileTypesModStatusSet: (fileTypesModStatus: StatusTypes) => void
  fileTypes: FileTypesDataTypes[]
  fileTypesSet: (fileTypes: FileTypesDataTypes[]) => void

  filesModErrors: StatusErrorTypes
  filesModErrorsSet: (filesModErrors: StatusErrorTypes) => void
  filesModStatus: StatusTypes
  filesModStatusSet: (filesModStatus: StatusTypes) => void
  files: FilesDataTypes[]
  filesSet: (files: FilesDataTypes[]) => void

  fileDownloadModErrors: StatusErrorTypes
  fileDownloadModErrorsSet: (fileDownloadModErrors: StatusErrorTypes) => void
  fileDownloadModStatus: StatusTypes
  fileDownloadModStatusSet: (fileDownloadModStatus: StatusTypes) => void
}

export const useFilesStore = create<FilesStoreTypes>((set) => ({
  fileTypesModErrors: '',
  fileTypesModErrorsSet: (fileTypesModErrors) => {
    set({
      fileTypesModErrors,
    })
  },
  fileTypesModStatus: 'idle',
  fileTypesModStatusSet: (fileTypesModStatus) => {
    set({
      fileTypesModStatus,
    })
  },
  fileTypes: [],
  fileTypesSet: (fileTypes) => {
    set({
      fileTypes,
    })
  },

  filesModErrors: '',
  filesModErrorsSet: (filesModErrors) => {
    set({
      filesModErrors,
    })
  },
  filesModStatus: 'idle',
  filesModStatusSet: (filesModStatus) => {
    set({
      filesModStatus,
    })
  },
  files: [],
  filesSet: (files) => {
    set({
      files,
    })
  },

  fileDownloadModErrors: '',
  fileDownloadModErrorsSet: (fileDownloadModErrors) => {
    set({
      fileDownloadModErrors,
    })
  },
  fileDownloadModStatus: 'idle',
  fileDownloadModStatusSet: (fileDownloadModStatus) => {
    set({
      fileDownloadModStatus,
    })
  },
}))
